<template>
<div>
    <!-- <div style="overflow-x: auto"> -->
        <table class="table ga-views has-mobile-cards"  v-if="client.ga_views.length > 0">
            <thead>
                <tr>
                    <th>Property</th>
                    <th>View</th>
                    <th>Goals</th>
                    <th>Ecommerce</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="view in client.ga_views" :key="view.view_id">
                    <td data-label="Property" v-text="view.property_id"></td>
                    <td data-label="View">
                        <a @click="showViewDetails(view)">
                            <span v-if="view.view_label === null" v-text="view.view_name"></span>
                            <span v-else v-text="view.view_label"></span>
                        </a>
                    </td>
                    <td data-label="Goals">{{ activeGoals(view) }}</td>
                    <td data-label="Ecommerce">{{ getEcommerce(view) }}</td>
                    <td data-label="Remove"><button class="btn btn-danger-outline btn-sm" @click="showDeleteConfirmation(view)">
                        <span class="fa fa-trash-o"></span>
                    </button></td>
                </tr>
            </tbody>
        </table>
        <div v-else>
            No Views Linked.
        </div>
    <!-- </div> -->

    <div class="modal fade" id="modal-delete-view" tabindex="-1" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button " class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                    <h4 class="modal-title">
                        Remove View?
                    </h4>
                </div>
                <div class="modal-body">
                    Are you 100% sure that you would like to remove this View?
                </div>
                <!-- Modal Actions -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" @click="deleteView" :class="{'btn-loading': loading}" :disabled="loading">Yes</button>
                    <button type="button" class="btn btn-default" data-dismiss="modal">Nope</button>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import {
	mapGetters
} from 'vuex';

export default {
	data() {
		return {
            loading: false,
            success: false
		}
	},

	computed: {
		...mapGetters('client', {
			'client': 'activeClient',
			'isAdmin': 'isAdmin',
		})
	},

	methods: {
		activeGoals(view) {
			return view.goals.filter((g) => g.status === "1").length;
		},

		getEcommerce(view) {
			return view.ecommerce === "1" ? 'Yes' : 'No';
        },

        showViewDetails(view) {
            this.$store.dispatch('client/showViewDetails', {view: view});
            history.pushState(null, null, `#/clients/${this.client.slug}/ga-views/${view.view_id}`);
            Bus.$emit('load-ga-goal-list');
        },

		showDeleteConfirmation(view) {
			this.activeView = view;
			$('#modal-delete-view').modal('show');
		},

		deleteView() {
            this.loading = true;
            let view = this.activeView;
			this.$store.dispatch('client/deleteGaView', {
					view: view
				})
				.then((response) => {
					Bus.$emit('show-success-alert', response.message);
					$('#modal-delete-view').modal('hide');
					this.reset();
				}).catch((error) => {
					console.log(error);
                    this.loading = false;
				})
		},

		reset() {
			Object.assign(this.$data, this.$options.data());
		}
	}
}
</script>

<style scoped lang="scss">
table.table.ga-views {
    tbody > tr > td {
        vertical-align: middle;
    }

    a:hover {
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/GaViewList.vue